import { useEffect, useState } from 'react'
import TextBox from '../Textboxs/Textbox'
import { Backdrop } from '../../Components'
import { Calendar, DateObject } from 'react-multi-date-picker'
import fa from 'react-date-object/locales/persian_fa'
import persian from 'react-date-object/calendars/persian'
import { TextBoxTypeEnum } from '../../../enums/TextBoxTypeEnum'
import Debounce from '../Textboxs/Debounce'
import Icon from '../Icons/Icons'

const DatePicker = ({
  Regular,
  RxgMessage,
  className,
  id,
  innerText,
  isRequired: isValid,
  msgValidate,
  name,
  onChange,
  onFocus,
  onBlur,
  isReadOnly,
  value,
  raytebValue,
  canDeleteDate

}: DatePickerInterface) => {
  const [isFocus, setFocus] = useState(false)
  const [date, setDate] = useState<Date | null>(null)
  const [valueShamsi, setValue] = useState<string | null | undefined>(null)
  const onFocusTextBox = () => {
    setFocus(true)
    onFocus && onFocus()
  }
  const onBlurTextBox = (date) => {
    setDate(date)
    setTimeout(() => {
      setFocus(false)
      onBlur && onBlur()
    }, 10)

    Debounce({
      func: () =>
        onChange?.({
          target: { value: new Date(date).toShamsi(), valueMiladi: date },
        }),
      timeout: 300,
    })
  }
  useEffect(() => {
    if (value)
      setValue(value)
  }, [value])
  return (
    <>
      <div className='relative'>
        {canDeleteDate === true && date != null ? <Icon icon='rayteb-android-close-b' className='text-danger text-xl px-1 absolute left-0 translate-y-1/2 z-10' onClick={() => {
          setDate(null)
          setValue(null)
        }} /> : <></>}
        <TextBox
          Regular={Regular}
          RxgMessage={RxgMessage}
          className={className}
          id={id}
          innerText={innerText}
          isRequired={isValid}
          debounceTime={0}
          msgValidate={msgValidate}
          name={name}
          Type={TextBoxTypeEnum.Text}
          onFocus={onFocusTextBox}
          value={date?.toShamsi() || valueShamsi || ''}
          isReadOnly={true}
          isLtR={false}
          raytebValue={date?.toISOString() || raytebValue}
        />
      </div>
      {isFocus ? (
        <>
          <Calendar
            className='fixed z-50 left-[50%]  right-[50%] translate-x-[50%] top-1/2 -translate-y-[50%]
             '
            locale={fa}
            calendar={persian}
            weekStartDayIndex={0}
            value={date}
            onChange={(e: DateObject) => {
              onBlurTextBox(e.toDate())
            }}

          />
          <Backdrop
            onClick={() => {
              setFocus(false)
            }}
          />
        </>
      ) : (
        ''
      )}
    </>
  )
}

export default DatePicker
